import { useState } from 'react'
import { useAuth } from '../../../libraries/auth'
import TextInput from '../../components/form/TextInput'
import Button from '../../components/form/Button'
import FormGroup from '../../components/form/FormGroup'
import ErrorMessage from '../../components/errors/ErrorMessage'
import { useI18N } from '../../../libraries/i18n/hook'
import { useNavigate } from 'react-router-dom'
import PasswordInput from '../../components/form/PasswordInput'

const SignupForm = () => {
  const { signup } = useAuth()
  const { t } = useI18N()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMessage('')
    setIsLoading(true)

    if (password !== confirmPassword) {
      setError(t('auth.signup.passwordMismatch') || 'Passwords do not match')
      setIsLoading(false)
      return
    }

    try {
      const result = await signup(username, password, confirmPassword)
      if (!result.success) {
        setError(result.error || 'Failed to sign up')
        return
      }
      navigate(`/verify-email?username=${encodeURIComponent(username)}`)
    } catch (err) {
      setError(`An unexpected error occurred ${err}`)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className='w-full space-y-6'>
      {error && <ErrorMessage error={new Error(error)} />}
      {message && (
        <div className='p-4 bg-green-50 text-green-700 rounded-md'>
          {message}
        </div>
      )}

      <FormGroup>
        <TextInput
          value={username}
          label={t('auth.login.username')}
          placeholder={t('auth.login.username')}
          name='username'
          onChange={(e) => setUsername(e.target.value?.trim())}
          required
          className='w-full border border-gray-600'
          type='email'
        />
      </FormGroup>

      <FormGroup>
        <PasswordInput
          value={password}
          label={t('auth.login.password')}
          placeholder={t('auth.login.password')}
          name='password'
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </FormGroup>

      <FormGroup>
        <PasswordInput
          value={confirmPassword}
          label={t('auth.signup.confirmPassword')}
          placeholder={t('auth.signup.confirmPassword')}
          name='confirmPassword'
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
      </FormGroup>

      <Button
        type='submit'
        variant='primary'
        size='md'
        loading={isLoading}
        disabled={isLoading}
        className='w-full'
      >
        {t('auth.signup.signUp')}
      </Button>
    </form>
  )
}

export default SignupForm
